import React from "react";
import { STEPS_STATES } from "../constants";
import { Icon } from "@iconify/react";

/**
 * Componente para renderizar un stepper de pasos.
 * @param {Object} props - Props del componente.
 * @param {Array<{index:number, path:string, currentState:string, backward?:boolean}>} props.steps - Arreglo de objetos que representan los pasos del stepper.
 * @param {Function} props.onClickStep - Función que se llama cuando se hace clic en un paso del stepper.
 * @returns {JSX.Element} Elemento JSX que representa el stepper.
 */
export const Stepper = (props) => {
	const { steps, onClickStep } = props;
	const currentActive = steps?.find((step) => step.currentState === STEPS_STATES.ACTIVE);

	return (
		<div className="stepper w-100">
			<div className="line" style={{ height: 5 }}></div>

			<div className="d-flex w-100 justify-content-between align-items-center">
				{steps.map((step, i) => {
					const disabledCursor =
						step?.currentState === STEPS_STATES.DISABLED ||
						step?.currentState === STEPS_STATES.ACTIVE ||
						(currentActive.backward !==true && step?.index < currentActive?.index);
					return (
						<button
							key={i}
							className={`step ${step?.currentState}`}
							style={{ cursor: disabledCursor ? "not-allowed" : "pointer" }}
							onClick={() => {
								if(!disabledCursor){
									onClickStep && onClickStep(step);
								}
							}}
						>
							{step.currentState === STEPS_STATES.COMPLETED ? (
								<Icon icon="ic:outline-check" className="" width={24} />
							) : null}
						</button>
					);
				})}
			</div>
		</div>
	);
};
